import React from 'react';
import InputMask from 'react-input-mask';
import moment from 'moment';

import * as actions from '../../../actions';
import { Context } from '../../../context';
import Input from '../../Input';
import { DefaultButton as Button } from '../../Button';
import {DefaultCheckbox as Checkbox} from '../../Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

function dateFormat(date) {
  return moment(date).utcOffset('+0000').format('DD MMMM YYYY HH:mm:ss')
}

function format(val) {
  const formatter = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' });
  return formatter.format(Math.abs(val || 0)).replace('.00', '');
}

function parseJwt (token) {
  if (!token) {
    return
  }
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  const parsedPayload = JSON.parse(jsonPayload);
  return {
    ...parsedPayload,
    firstName: parsedPayload.firstName || '',
    lastName: parsedPayload.lastName || '',
    middleName: parsedPayload.middleName || ''
  }
};

export default ({ classes, changeStep, signupTrigger, changeSignupTrigger }) => {
  const { state: { insurance }, dispatch } = React.useContext(Context);
  const [creatorData, changeCreatorData] = React.useState(insurance.creator)
  const [users, changeUsers ] = React.useState(insurance.insurers);
  
  const changeTelemedicine = () => {
    actions.updateInsurance({
      id: insurance.id,
      telemedicine: !insurance.telemedicine,
    }, dispatch)
  }
  
  const onChange = name => ({ target: { value } }) => {
    const updatedData = Object.assign(creatorData, { [name]: value });
    changeCreatorData(updatedData)
    dispatch({
      type: 'updateCreatorSuccess',
      payload: updatedData,
      loading: true
    })
  }

  const token = typeof window !== 'undefined' ? window.localStorage.getItem('token') : null;
  const potentialCreator = parseJwt(token)
  let potentialCreators = insurance.insurers

  const handleChangeDate = name => ({ target: { value } }) => {
    let splitedDate = value.split('-');
    if (value.length > 7) {
      const mm = Number(splitedDate[1]) > 12 ? 12 : splitedDate[1];
      splitedDate[1] = mm;
      const mmDays = moment(`01-${mm}`, 'DD-MM').daysInMonth();
      if (Number(splitedDate[0]) > mmDays) {
        splitedDate[0] = mmDays
      }
      if (Number(splitedDate[2]) > moment().get('years')) {
        splitedDate[2] = moment().get('years')
      }
    }
    const updatedData = Object.assign(creatorData, { [name]: splitedDate.join('-') });
    changeCreatorData(updatedData)
    dispatch({
      type: 'updateCreatorSuccess',
      payload: updatedData,
      loading: true
    })
  }

  React.useEffect(() => {
    if (signupTrigger) {
      actions.signUp({
        ...creatorData,
        insuranceId: insurance.id,
      }, dispatch, () => {
        actions.payInsurance({
          insuranceId: insurance.id,
          successUrl: process.env.SUCCESS_URL,
          errorUrl: process.env.ERROR_URL,
        }, dispatch, () => {
          changeSignupTrigger(false)
        });
      });
    }
  }, [signupTrigger]);

  const selectCreatorFromInsured = ({firstName, lastName, middleName, birthday, email}) => () => {
    const creatorData = {
      firstName,
      lastName,
      middleName,
      birthday: moment(birthday).format('DD-MM-YYYY'),
      email: email || '',
    }
    changeCreatorData(creatorData)
    dispatch({
      type: 'updateCreatorSuccess',
      payload: creatorData,
      loading: true
    })
  }

  return (
    <React.Fragment>
      <p className={classes.paymentTitle}>Страхователь</p>
      <div className={classes.insuredDetailsContainer}>
      {potentialCreator ? <Button classes={{ root: classes.insuredDetails }} onClick={selectCreatorFromInsured(potentialCreator)}>HELLO</Button> : null}
      {
        potentialCreators.map(x => (
              <Button key={x.id} classes={{ root: classes.insuredDetails }} onClick={selectCreatorFromInsured(x)}>
                {(x.firstName && x.lastName && x.middleName )? `${x.firstName} ${x.middleName} ${x.lastName}` : x.email}
              </Button>
          ))
        }
      </div>
      <div className={classes.paymentItem}>
        <div className={classes.paymentInput}>
          <label htmlFor="first-name">Имя</label>
          <Input
            id="first-name"
            onChange={onChange('firstName')}
            value={insurance.creator.firstName}
            placeholder="Имя"
          />
        </div>
        <div className={classes.paymentInput}>
          <label htmlFor="middle-name">Отчество</label>
          <Input
            id="middle-name"
            onChange={onChange('middleName')}
            value={insurance.creator.middleName}
            placeholder="Отчество"
          />
        </div>
        <div className={classes.paymentInput}>
          <label htmlFor="last-name">Фамилия</label>
          <Input
            id="last-name"
            onChange={onChange('lastName')}
            value={insurance.creator.lastName}
            placeholder="Фамилия"
          />
        </div>
        <div className={classes.paymentInput}>
          <label htmlFor="birthday">Дата рождения</label>
          <InputMask
            mask="ДД-ММ-ГГГГ"
            maskChar={null}
            alwaysShowMask={false}
            onChange={handleChangeDate('birthday')}
            value={insurance.creator.birthday}
            formatChars={{
              "Д": "[0-9]",
              "Г": "[0-9]",
              "М": "[0-9]"
            }}
          >
            {(props) => (<Input id="birthday" {...props} placeholder="ДД-ММ-ГГГГ" />)}
          </InputMask>
        </div>
        <div className={classes.paymentInput}>
          <label htmlFor="email">Почта</label>
          <Input
            id="email"
            onChange={onChange('email')}
            value={insurance.creator.email}
            placeholder="Почта"
          />
        </div>
        <div className={classes.paymentInput}>
          <label htmlFor="phone">Номер телефона</label>
          <InputMask
            mask="+7(999)999-99-99"
            maskChar={null}
            onChange={onChange('phone')}
            alwaysShowMask={false}
            // autoComplete
            value={insurance.creator.phone}
            placeholder="Телефон"
          >
            {(props) => (<Input id="phone" {...props} />)}
          </InputMask>
        </div>

                {/* <FormControlLabel
                  control={<Checkbox 
                              onChange={changeTelemedicine}
                              checked={insurance.telemedicine}
                              value="telemedicine"
                              color="primary" />}
                  label="Телемедицина"
                  labelPlacement="end"
                  disableRipple
                  color="primary"
                /> */}
          {/* <FormControlLabel
            classes={{ root: classes.controlLabel }}
            control={
              <Switch
                focusVisibleClassName={classes.focusVisible}
                disableRipple
                classes={{
                  root: classes.rootSwitch,
                  switchBase: classes.switchBase,
                  thumb: classes.thumb,
                  track: classes.track,
                  checked: classes.checked,
                }}
                checked={insurance.telemedicine}
                value="telemedicine"
                onChange={changeTelemedicine}
              />
            }
            label={insurance.telemedicine ? 'Добавить телемедицину' : 'Не добавлять телемедицину' }
          /> */}


      </div>
      <div className={classes.paymentFooter}>
        <div className={classes.paymentFooterTitle}>Информация о страховке</div>
        <div className={classes.paymentFooterItem}>
          <div className={classes.paymentFooterItemName}>
            Период страхования:
          </div>
          <div className={classes.paymentFooterItemValue}>
            {dateFormat(insurance.startDate)} по {dateFormat(insurance.expirationDate)}
            {/* {<b>{moment(date).utcOffset('+0000').format('DD MMMM YYYY HH:mm:ss')}</b> - <b>{moment(insurance.expirationDate).utcOffset('+0000').format('DD MMMM YYYY HH:mm:ss')}</b>} */}
            {/* {`${moment(insurance.startDate).format('DD-MM-YYYY')} - ${moment(insurance.expirationDate).format('DD-MM-YYYY')}`} */}
          </div>
        </div>
        <div className={classes.paymentFooterItem}>
          <div className={classes.paymentFooterItemName}>
            Вид спорта:
          </div>
          <div className={classes.paymentFooterItemValue}>
            {
              insurance.pickedSports.map(x => x.title).join(', ')
            }
          </div>
        </div>
        <div className={classes.paymentFooterItem}>
          <div className={classes.paymentFooterItemName}>
            С соревнованиями:
          </div>
          <div className={classes.paymentFooterItemValue}>
            {insurance.isCompetition ? 'Да' : 'Нет'}
          </div>
        </div>
        <div className={classes.paymentFooterItem}>
          <div className={classes.paymentFooterItemName}>
            Территория:
          </div>
          <div className={classes.paymentFooterItemValue}>
            {(insurance.location.alpha3 === 'RUS') ? 'Россия' : 'Весь мир, включая Россию' }
          </div>
        </div>
        <div className={classes.paymentFooterItem}>
          <div className={classes.paymentFooterItemName}>
            Сумма страховки:
          </div>
          <div className={classes.paymentFooterItemValue}>
            {format(insurance.totalPrice)}
          </div>
        </div>
        <div className={classes.paymentFooterItem}>
          <div className={classes.paymentFooterItemName}>
            Страховой пакет:
          </div>
          <div className={classes.paymentFooterItemValue}>
            {insurance.packet.title}
          </div>
        </div>
        <div className={classes.paymentFooterItem}>
          <div className={classes.paymentFooterItemName}>
            Покрытие рисков:
          </div>
          <div className={classes.paymentFooterItemValue}>
            <ul>
              {insurance.packet.includeList.map(x => <li>{x}</li>)}
            </ul>
          </div>
        </div>
        <div className={classes.paymentFooterTitle}>Застрахованные лица</div>
        <div className={classes.paymentFooterItemHeader}>
          <div className={classes.paymentFooterItemHeaderName}>
            ФИО
          </div>
          <div className={classes.paymentFooterItemHeaderValue}>
            Дата рождения
          </div>
        </div>
        {
          insurance.insurers.map(x => (
            <div key={x.id} className={classes.paymentFooterItem} onClick={() => changeStep(1)}>
              <div className={classes.paymentFooterItemName}>
                {`${x.lastName} ${x.firstName} ${x.middleName}`}
              </div>
              <div className={classes.paymentFooterItemValue}>
                {moment(x.birthday).format('DD MMMM YYYY')}
              </div>
            </div>
          ))
        }
      </div>
    </React.Fragment>
  )
}
